import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, Phone, X } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetTrigger, SheetClose } from './ui/sheet';
import { COMPANY, NAV_LINKS } from '../data/mock';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-[0_4px_24px_-12px_rgba(20,50,25,0.25)] py-3' : 'bg-white/80 backdrop-blur-sm py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <img src={COMPANY.logo} alt="360 Mold Services logo" className={`w-auto transition-all duration-300 ${scrolled ? 'h-14' : 'h-16 lg:h-[72px]'}`} />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === '/'}
              className={({ isActive }) =>
                `nav-link text-[15px] font-medium transition-colors ${
                  isActive ? 'text-brand active' : 'text-[#33443a] hover:text-brand'
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a href={COMPANY.phoneHref} className="flex items-center gap-2 text-[#16231b] font-semibold hover:text-brand transition-colors">
            <span className="h-9 w-9 rounded-full bg-[#eaf4dd] flex items-center justify-center">
              <Phone className="h-4 w-4 text-brand" />
            </span>
            <span className="text-sm leading-tight">{COMPANY.phone}</span>
          </a>
          <Button asChild className="bg-brand hover:bg-[#5c9a22] text-white rounded-full px-6 font-semibold">
            <Link to="/contact">Book Inspection</Link>
          </Button>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <a href={COMPANY.phoneHref} className="h-10 w-10 rounded-full bg-[#eaf4dd] flex items-center justify-center">
            <Phone className="h-4 w-4 text-brand" />
          </a>
          <Sheet>
            <SheetTrigger asChild>
              <button className="h-10 w-10 rounded-full border border-[#dce7d3] flex items-center justify-center text-[#16231b]">
                <Menu className="h-5 w-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] p-0">
              <div className="p-6 border-b flex items-center justify-between">
                <img src={COMPANY.logo} alt="logo" className="h-10" />
                <SheetClose className="h-8 w-8 flex items-center justify-center rounded-full hover:bg-muted">
                  <X className="h-5 w-5" />
                </SheetClose>
              </div>
              <nav className="flex flex-col p-4">
                {NAV_LINKS.map((link) => (
                  <SheetClose asChild key={link.to}>
                    <NavLink
                      to={link.to}
                      end={link.to === '/'}
                      className={({ isActive }) =>
                        `px-4 py-3 rounded-lg text-[15px] font-medium ${
                          isActive ? 'bg-[#eaf4dd] text-brand' : 'text-[#33443a] hover:bg-muted'
                        }`
                      }
                    >
                      {link.label}
                    </NavLink>
                  </SheetClose>
                ))}
                <SheetClose asChild>
                  <Button asChild className="mt-4 bg-brand hover:bg-[#5c9a22] text-white rounded-full font-semibold">
                    <Link to="/contact">Book Inspection</Link>
                  </Button>
                </SheetClose>
                <a href={COMPANY.phoneHref} className="mt-3 text-center text-sm font-semibold text-[#16231b]">
                  {COMPANY.phone}
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
